import React from 'react'
import { PropTypes } from 'prop-types'

const FormFieldValidation = props => (
  <div>
    {
      props.errorMessages && props.errorMessages.map((errorMessage, index) => (
        <p
          id={(props.htmlFor ? `${props.htmlFor}Error` : 'error') + index}
          key={errorMessage}
          className="ln-c-field-info ln-c-field-info--error"
        >{errorMessage}</p>
      ))
    }
  </div>
)

FormFieldValidation.propTypes = {
  errorMessages: PropTypes.arrayOf(
    PropTypes.string
  ),
  htmlFor: PropTypes.string.isRequired
}

FormFieldValidation.defaultProps = {
  errorMessages: []
}

export default FormFieldValidation



// WEBPACK FOOTER //
// ./src/components/FormFieldValidation/index.jsx